import LocationInterface from '@solvhealth/types/interfaces/Location';
import { GenericObj } from '@solvhealth/types/interfaces/generics';
import React from 'react';
import withAuthentication from '../../../../../core/login/withAuthentication';
import { PaperworkStatus, PaperworkFieldName } from '../../../paperworkConstants';
import LoadingScreen from '~/components/SolvPatternLibrary/LoadingScreen';
import PaperworkLayout from '../../../PaperworkLayout';
import {
  useInitializePaperworkData,
  useGoForwardAndBack,
  useIncrementProgress,
  useTabTitle,
  useTitles,
} from '../../../hooks';
import PatientForm from './PatientForm';
import { PaperworkState } from '~/ducks/paperwork';
import { PGSectionNumber } from '../../constants';
import { PATIENT_PAGES } from './constants';

type Props = {
  bookingId: string;
  paperwork: PaperworkState;
  submitPaperworkPage: (
    newForm: GenericObj,
    bookingId: string,
    paperworkStatus: string,
    onSuccess: (...args: any[]) => void,
    isProviderGroup: boolean
  ) => void;
  preloadedData?: any;
  location: LocationInterface;
};

const PaperworkPatient = (props: Props) => {
  const { paperwork, preloadedData, bookingId, location, submitPaperworkPage } = props;

  useTabTitle(PGSectionNumber.Patient, PGSectionNumber);
  useInitializePaperworkData(paperwork, bookingId, location);
  useIncrementProgress(PGSectionNumber.Patient, paperwork.pageView);

  const [goForwardAPage, goBackAPage] = useGoForwardAndBack(
    PGSectionNumber.Patient,
    PGSectionNumber,
    bookingId
  );

  const onGoForward = () => goForwardAPage();
  const onGoBack = () => goBackAPage();

  const handleClickNext = (newForm: GenericObj) => {
    submitPaperworkPage(newForm, bookingId, PaperworkStatus.IN_PROGRESS, goForwardAPage, true);
  };

  const [title, subtitle] = useTitles(PGSectionNumber.Patient, PGSectionNumber, {
    name: paperwork.formData[PaperworkFieldName.PATIENT_FIELD_FIRST_NAME],
    guardian_name: paperwork.formData[PaperworkFieldName.GUARDIAN_FIRST_NAME],
  });

  const sectionPage = PATIENT_PAGES.get(paperwork.pageView);
  if (!paperwork || !paperwork.standardFields || !sectionPage) {
    return <LoadingScreen />;
  }
  return (
    <PaperworkLayout
      onGoBack={onGoBack}
      section={PGSectionNumber.Patient}
      subtitle={subtitle}
      title={title}
    >
      <PatientForm
        bookingId={bookingId}
        handleClickNext={handleClickNext}
        location={location}
        onGoForward={onGoForward}
        pageView={paperwork.pageView}
        paperwork={paperwork}
        preloadedData={preloadedData}
        sectionPage={sectionPage}
      />
    </PaperworkLayout>
  );
};

export default withAuthentication(PaperworkPatient);
